export const WC_PROJECT_ID = "611166d0acff5c338dda9561d4a31acc"

export const OPX_ADDRESS = "0xa3fb72cbf2e07dc1b34aea569ed40755fd978bd8"


